import e from"react";import r from"./backdrop.style.module.scss.js";var t=function(t){var a=t.show,o=t.onClick;return a?e.createElement("div",{className:r.backdrop,onClick:o}):e.createElement(e.Fragment,null)};export{t as default};
//# sourceMappingURL=backdrop.js.map
